// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".comment-alert-module__alertWrapper--3vDPI{display:flex;justify-content:flex-start;gap:10px;align-items:center;padding:15px 15px 15px 17px;box-sizing:border-box}.comment-alert-module__alertWrapper--3vDPI.comment-alert-module__info--3M3vu{background-color:#eff3fe}.comment-alert-module__alertWrapper--3vDPI.comment-alert-module__error--gYpCr{background-color:rgba(221,28,26,.1)}.comment-alert-module__alertIcon--2QKYF{flex-shrink:0;width:24px;height:24px}", ""]);
// Exports
exports.locals = {
	"alertWrapper": "comment-alert-module__alertWrapper--3vDPI",
	"info": "comment-alert-module__info--3M3vu",
	"error": "comment-alert-module__error--gYpCr",
	"alertIcon": "comment-alert-module__alertIcon--2QKYF"
};
module.exports = exports;
